/* eslint-disable */
import requestDev from '@/utils/requestDev'
import requestRawBasic from '@/utils/requestRawBasic'
import requestRawJWT from '@/utils/requestRaw'
import { APICore, APIReportPHP } from '@/utils/servicesApi'
const qs = require('qs')

export function extendLicense(data) {
  return requestRawJWT({
    url: APICore() + '/license/extend-license',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function getActiveVoucher(id) {
  return requestRawJWT({
    url: APICore() + '/voucher/get-active-voucher?voucher_id=' + id,
    method: 'GET',
  })
}

export function voucherList(params) {
  return requestDev({
    url: APIReportPHP() + '/order/voucher-list',
    method: 'POST',
    data: qs.stringify(params)
  })
}


export function orderList(params) {
  return requestDev({
    url: APIReportPHP() + '/order/list',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function selectPayment(data) {
  return requestRawBasic({
    url: APICore() + '/order/update-select-payment',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function getInvoice(params) {
  return requestRawBasic({
    url: APICore() + '/order/get-invoice',
    method: 'POST',
    data: params
  })
}

export function createOrder(data) {
  return requestRawBasic({
    url: APICore() + '/order/stored',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function createPayment(data) {
  return requestRawBasic({
    url: APICore() + '/pay/stored',
    method: 'POST',
    data: data // untuk array data post
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js